export default __webpack_public_path__ + "static/media/chi.ce4bedbc.jpg";